<script setup>
  import { useChartPreview } from "../composables/useChartPreview";
  import { usePieChart } from "../composables/usePieChart";

  const props = defineProps({
    colors: { type: Array, required: true },
    width: { type: Number, required: true },
    height: { type: Number, required: true },
    padding: { type: Number, required: true },
    seriesCount: { type: Number, required: true },
    categoryCount: { type: Number, required: true },
  });

  const { chartWidth, chartHeight, displayColors } = useChartPreview(props);
  const { doughnutSlices } = usePieChart(props, chartWidth, chartHeight);
</script>

<template>
  <g :transform="`translate(${width / 2}, ${height / 2})`">
    <path
      v-for="(slice, i) in doughnutSlices"
      :key="i"
      :d="slice.path"
      :fill="displayColors[i % displayColors.length]" />
  </g>
</template>
